/* eslint-disable */

import { request, queryUrl } from '../../tools/utils';
import NewsListItem from './new-item';
import NextPage from './next_page';
export default {
    name: "News",
    props: ['text'],
    data() {
        return {
          data: [],
          dataLen: 0,
          pageSize: 10,
          pageNumber: 1,
          tag: ""
        }
    },
    template: `
    <div class="container">
      <div class="item-warp"> 
          <div class="item" v-for="i,index in data" @click="goDetails(i)" >
              <news-list-item
                  :key="index"
                  :coverUrl="i.image"
                  :title="i.title"
                  :readNum="i.browseNum"
                  :date="i.createTime"
                  :newsId="i.newsId"
              ></news-list-item>
          </div>
      </div>
      <div class="no-data" style="display: none;" v-show="data.length === 0">无数据</div>
      <next-page :text="'加载更多'" :dataLen="dataLen" v-on:mousetouch="loadMore"></next-page>
  </div>`,

    beforeMount() {
        window.scrollTo(0, 0);
        let tag = queryUrl(window.location.href).tag || '';
        this.tag = tag;
        this.loadData(tag);
    },
    methods: {
        goDetails(news) {
            
        },
        loadData(tag, pageSize, pageNumber) {
            request.get({
                _this: this,
                api: 'newsList',
                data: {
                    iid: window.__iid || '',
                    pageSize: pageSize ? pageSize : 10 ,
                    pageNumber: pageNumber ? pageNumber : 1,
                    tag: tag || ''
                },
                success: function (data) {
                  if (data && data.code === 0) {
                    this.dataLen = data.t.length;
                    this.data = this.data.concat(data.t);
                  }
                },
                error: function (data) {
                    
                }
            });
        },
        loadMore() {
            this.pageNumber = this.pageNumber + 1;
            this.loadData(this.tag, this.pageSize, this.pageNumber)
        }
    },
    components: {
        'news-list-item': NewsListItem,
        'next-page': NextPage
    }
}